import { useState, useEffect } from 'react';

const useBrowserInfo = () => {
  const [browserInfo, setBrowserInfo] = useState({
    appName: '',
    appVersion: '',
    userAgent: '',
    platform: ''
  });

  useEffect(() => {
    setBrowserInfo({
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      userAgent: navigator.userAgent,
      platform: navigator.platform
    });
  }, []);

  return browserInfo;
};

export default useBrowserInfo;